import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import React from 'react';
import Label from 'components/form/Label/Label';
import { Row } from 'components/Containers/Row/Row';
import { Button } from 'components/form/Button';
import { useHistory } from 'react-router-dom';
import { useEventHandler } from 'hook/event.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import CenterAlignBox from 'components/Containers/CenterAlignBox';
import { Image } from 'components/Image/Image';
import { isInvisibleUser } from 'helpers/userHelper';
import { CREDIT_BUILDER_VERTICAL } from 'types/mrph.vertical.constants';
import { useFlag } from 'hook/flag.hook';
import { isNonControlVariationLoadedAndEnabled } from 'helpers/optimizely.helper';
import './BoosterEnrollmentEntryPoint.scss';

const MODULE_NAME = 'Booster Enrollment Prompt';

const BoosterEnrollmentEntryPoint = props => {
  const cb20GaWebFlag = useFlag('cb2_0_ga_web');
  const isCb20GaWebFlag = isNonControlVariationLoadedAndEnabled(cb20GaWebFlag);
  const history = useHistory();
  const eventHandler = useEventHandler();

  const atr = getViewModuleTrackingAttributes({
    pagePosition: MODULE_NAME,
    modulePosition: props.modulePosition,
    vertical: CREDIT_BUILDER_VERTICAL,
  });
  const seenPixel = useSeenModulePixel(atr);
  const onClickEnrollInBuilder = () => {
    eventHandler(CLICK, {
      'Click Type': 'Booster Enrollment Prompt',
      'Module Name': MODULE_NAME,
      Vertical: CREDIT_BUILDER_VERTICAL,
    });
    history.push('/cash/builderEnrollmentLanding');
  };

  let text = {
    title: 'Finish Activating Credit Builder!',
    subtitle:
      'Grow your credit score an average of 35 points with the cash you have and the debit purchases you make.¹ No credit check needed!',
    ctaText: 'Activate Credit Builder Now',
  };

  if (props?.creditInfo?.creditScore > 700) {
    text = {
      title: 'Use your debit to grow your credit!',
      subtitle:
        'Grow your credit score an average of 35 points with the cash you have and the debit purchases you make.¹ No credit check needed!',
      ctaText: 'Activate Credit Builder Now',
    };
  }

  if (isInvisibleUser(props.userInfo)) {
    text.subtitle =
      'Establish your credit with the cash you have and the debit purchases you make.1 No credit check needed!';
  }

  if (isCb20GaWebFlag && cb20GaWebFlag?.config?.module_cb10_upsell?.show) {
    text = cb20GaWebFlag?.config?.module_cb10_upsell?.copyConfig;
  }

  if (isCb20GaWebFlag && !cb20GaWebFlag?.config?.module_cb10_upsell?.show) {
    return <></>;
  } else {
    return (
      <>
        {seenPixel}
        <SectionContainer>
          <Row>
            <FlexContainer className="flex-row t-flex-column BoosterEnrollmentEntryPoint">
              <CenterAlignBox widthClassName="format40 m-format100 ">
                <Image imgClass="boosterEnrollmentEntryPointHero" />
              </CenterAlignBox>
              <FlexContainer className="flex-column format60 m-format100 m-padT16">
                <div className="padB16 m-padB8">
                  <Label type="H3 t-hide">{text?.title}</Label>
                  <Label type="H5 d-hide">{text?.title}</Label>
                </div>
                <Label className="Body-2">{text?.subtitle}</Label>
                <div className="padTB16 m-padTB12"></div>
                <div className=" text-right">
                  <Button
                    onClick={onClickEnrollInBuilder}
                    datatestid="booster-enroll-entry-cta"
                    mrphType="primary"
                    className="padLR60"
                  >
                    {text?.ctaText}
                  </Button>
                </div>
              </FlexContainer>
            </FlexContainer>
          </Row>
        </SectionContainer>
      </>
    );
  }
};

export default BoosterEnrollmentEntryPoint;
